import * as action from "../types.variables";

export function addToFavourite(phonebookEntry) {
  return {
    type: action.PHONEBOOK_ADD_TO_FAVORITE,
    payload: phonebookEntry,
  };
}

export function removeFromFavourite(id) {
  return {
    type: action.PHONEBOOK_REMOVE_FROM_FAVORITE,
    payload: id,
  };
}

export function setFavouritesFromStorage(favorites) {
  return {
    type: action.PHONEBOOK_READ_FAVORITE_FROM_COOKIE,
    payload: favorites,
  };
}
